import { useState, useRef } from 'react'
import TextareaAutosize from 'react-textarea-autosize'

export default function RpTextArea({ max, field, error }) {
  const [ wordCount, setWordCount ] = useState(0)
  const [ content, setContent ] = useState('')

  return (
    <label className="block">
      <div className="mb-3 with-required">Tell us about this moment</div>

      <TextareaAutosize placeholder="Enter a description…" className="
        mt-1 text-md pt-4 pb-3 px-5 block w-full rounded-3xl border-gray-400 placeholder-gray-400 shadow-sm resize-none
        focus:border-gray-400 focus:ring focus:ring-gray-300 focus:ring-opacity-50" 
        minRows={10}
        onChange={handleKeypress}
        value={content}
        ref={field.ref} // set ref for react-hook-form
      />

      <div className="pt-3 flex justify-between text-sm uppercase">
        <div className="text-red-600">{error && "This field is required"}</div>
        <div className="">{wordCount} / {max} words</div>
      </div>
    </label>
  )

  function handleKeypress (event) {
    let content = event.target.value
    let words = content.split(' ').filter(Boolean)
    let count = content.length ? words.length : 0

    if (count > max) {
      content = words.slice(0, max).join(' ')
      words = max
    }

    setContent(content)
    setWordCount(count)

    // call react-hook-form onChange
    field.onChange(event)
  }
}